export const AUTO_STAGES = ["estimate", "scheduled", "in_progress", "waiting_parts", "ready", "completed", "cancelled"];

export const ACTIVE_STAGES = AUTO_STAGES.filter((stage) => !["completed", "cancelled"].includes(stage));

export const URGENCY_STYLES = {
  low: "bg-slate-100 text-slate-700 border-slate-200",
  medium: "bg-blue-100 text-blue-800 border-blue-200",
  high: "bg-amber-100 text-amber-800 border-amber-200",
  unsafe: "bg-red-100 text-red-800 border-red-200",
};

export const URGENCY_LABEL = {
  low: "Low",
  medium: "Medium",
  high: "High",
  unsafe: "Unsafe",
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
};

// How long the work order has sat in its CURRENT stage, from stage_history's
// most recent entry — distinct from created_at, which is when it entered the
// queue at all. A card that's been "waiting_parts" for 3 days should look
// different from one that just moved there.
export const timeInCurrentStage = (order) => {
  const history = order?.stage_history || [];
  const entered = history.length ? history[history.length - 1].entered_at : order?.created_at;
  if (!entered) return null;
  const ms = Date.now() - new Date(entered).getTime();
  if (ms < 0 || Number.isNaN(ms)) return null;
  const hours = Math.floor(ms / 3600000);
  if (hours < 1) return `${Math.max(1, Math.floor(ms / 60000))}m`;
  if (hours < 24) return `${hours}h`;
  return `${Math.floor(hours / 24)}d`;
};
